import.meta.glob([
    '../images/**',
    '../fonts/**',
])

import axios from 'axios'
window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

import '../scss/app.scss'